import type { CustomIconProps } from '../types';

const ChevronRight = ({ width, height, color }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '6px'}
        height={height ?? '12px'}
        viewBox="0 0 6 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.0901553 0.111551C0.216065 -0.030653 0.427011 -0.037858 0.561315 0.0954586L5.89465 5.38958C5.95922 5.45368 5.99707 5.54234 5.99984 5.63602C6.0026 5.7297 5.97007 5.8207 5.9094 5.88895L0.576068 11.889C0.449896 12.0309 0.238937 12.0377 0.104879 11.9041C-0.0291784 11.7705 -0.0355711 11.5471 0.0906011 11.4052L5.19503 5.66268L0.105354 0.610426C-0.02895 0.477109 -0.0357547 0.253756 0.0901553 0.111551Z"
            fill={color ?? '#7A797B'}
        />
    </svg>
);

export default ChevronRight;
